<template>
  <div id="visa-top-infos">
    <!-- 头部 -->
    <div class="info-header">
      <div class="row-one">
        <div class="visa-product-name">
          {{ product.product_name }}
          <!-- 下架icon -->
          <div
            class="product-out-icon"
            v-if="
              product.status === 1 &&
              specialProduct.indexOf(product.visa_product_id) === -1
            "
          ></div>
        </div>
        <div class="close-box" @click="$router.back()">
          <div class="icon-close"></div>
        </div>
      </div>

      <div class="row-two">
        <div class="left-box">
          <div class="visa-tags">
            <div class="tag-item primary" :style="{ background: visaTypeBg }">
              {{ product.visa_type }}
            </div>
            <div
              class="tag-item green-tag"
              v-if="product.need_flight_hotel"
            >
              机酒代订
            </div>
            <div class="tag-item red-tag" v-if="+product.need_urgent">加急</div>
            <div
              class="tag-item blue-tag"
              v-if="+product.need_simplify_material"
            >
              简化资料
            </div>
            <div
              class="tag-item blue-tag"
              v-if="
                +product.need_interview === 2 || +product.need_delivery === 2
              "
            >
              含陪签
            </div>
            <div class="tag-item blue-tag" v-if="+product.need_insurance">
              含保险
            </div>
            <div class="tag-item blue-tag" v-if="+product.need_evus">
              含EVUS
            </div>
            <div class="tag-item blue-tag" v-if="+product.need_free_shipping">
              顺丰包回邮
            </div>
            <!-- <div class="need-reject-label" v-if="product.need_reject_product && product.reject_product_set && product.reject_product_set.length"></div> -->
          </div>
          <div class="product-num">
            <base-text-copy :text="product.visa_product_id">商品编号：{{ product.visa_product_id }}</base-text-copy>
          </div>
        </div>
        <div class="right-box">
          <div class="update-time" v-if="product.visa_product_update_time">
            更新时间：{{ dayjs(product.visa_product_update_time).format('YYYY-MM-DD HH:mm') }}
          </div>
        </div>
      </div>
    </div>

    <div class="product-price-info-wrap">
      <!-- 价钱等 -->
      <div class="price-and-coupon">
        <div class="product-price-box">
          <div class="price-box">
            <div v-if="product.special_price" class="special-price-tag"> </div>
            <div v-if="product.after_coupon_price !== undefined" class="coupon-price-tag">券后价</div>
            <div class="current-price" :class="{ 'hide-price': !User.isLogin() }">
              <span class="price-sign">￥</span>
              <span class="price-number" v-if="User.isLogin()">{{
                productShowPrice
              }}</span>
              <span class="pre" v-if="User.isLogin()">/人</span>
              <span class="price-number" v-else>-</span>
            </div>
            <div class="login-btn" @click="goToLogin" v-if="!User.isLogin()">
              登录可见
            </div>

            <div
              class="origin-price"
              v-if="
                product.special_price || product.after_coupon_price !== undefined
              "
            >
              <span class="origin-price-number"
                >￥{{ product.peer_price / 100 }}</span
              >
            </div>

            <!-- 当前组件只支持0点，但该特价显示需要支持到24点，需要额外添加一个参数is-support-equal -->
            <count-down
              :endTime="product.special_end_date"
              :is-support-equal="true"
              v-if="product.special_price && !isShowSpecialPriceTag"
            ></count-down>

            <div class="coupon-box" v-if="product.after_coupon_price !== undefined">
              <div v-if="product.available_coupon_info.peer_coupon_type_id === 0">
                {{
                  '立减' + product.available_coupon_info.cash_reduce / 100
                }}·仅限1单
              </div>
              <div v-if="product.available_coupon_info.peer_coupon_type_id === 1">
                {{
                  '立享' + formatDiscount + '折'
                }}·仅限1单
              </div>
            </div>
          </div>
          <div class="product-price-bottom">
            
            <div class="suggestion-price">
              建议零售价: <span>¥</span>{{ $showPrice(product.original_price) }}
            </div>
          </div>
        </div>
        <div class="hanle-buttons">
          <div class="visa-comment" @click="$emit('scroll-to-section', '#product-comment')">评价<span>（{{commentTotal}}）</span></div>

          <div class="create-order-btn-list" v-display:create-visa-order>
            
            <template v-if="product.status === 0">
              
              <el-tooltip
                v-if="User.isLogin()"
                  class="tips"
                  effect="dark"
                  content="点击可以分享商品给客户，由客户填写个人资料。在分享时，可以点击【填写价格】编辑您想告知客户的电子签价格，我们将不会向您的客户以任何形式展示来自上上签信息以及采购价。"
                  placement="top"
                  popper-class="visa-top-infos-tooltip"
                >
                <button class="handle-btn is-share" @click="shareToCustomer">
                  <div class="btn-title">分享给顾客</div>
                  <div class="btn-subtitle">由顾客提交资料</div>
                </button>
              </el-tooltip>
              <button v-else class="handle-btn is-share" @click="shareToCustomer">
                <div class="btn-title">分享给顾客</div>
                <div class="btn-subtitle">由顾客提交资料</div>
              </button>
              

              <button class="handle-btn primary" @click="addOrderNow">
                立即办理
              </button>
            </template>
            <button
              v-else-if="specialProduct.indexOf(product.visa_product_id) > -1"
              class="handle-btn primary"
              @click="showSpecialTips"
            >
              立即办理
            </button>
            <button
              class="handle-btn disabled"
              disabled
              v-else-if="product.status === 1"
            >
              商品已下架
            </button>
          </div>
          
        </div>
      </div>

      <div class="price-desc-box">
        <div class="desc-item" v-if="product.price_detail && User.isLogin()">
          <div class="item-label">价格说明：</div>
          <div class="item-content">{{product.price_detail}}</div>
        </div>
        <div class="desc-item" v-if="serviceInclude && serviceInclude.content">
          <div class="item-label">服务范围：</div>
          <div class="item-content">{{serviceInclude.content}}</div>
        </div>
      </div>
    </div>

    <div class="product-base-info">
      <div class="left-box">
        <div class="base-info-item">
          <div class="item-label">办理时长</div>
          <div class="item-content">
            <span v-if="product.need_days === product.need_days_longest">{{ product.need_days + product.op_need_days }}个工作日</span>
            <span v-else>{{ product.need_days + product.op_need_days }}-{{ product.need_days_longest + product.op_need_days }}个工作日</span>
            <el-tooltip
              placement="right"
              :content="needDaysTooltipContent"
              popper-class="new-visa-top-infos-tooltip"
            >
              <span class="tooltip-icon"></span>
            </el-tooltip>
          </div>
        </div>
        <div class="base-info-item">
          <div class="item-label">有效期</div>
          <div class="item-content">
            <span v-if="product.common_info[0].type === 0">{{ product.common_info[0].num }}{{ product.common_info[0].unit }}</span>
            <span v-else>{{ product.common_info[0].unit }}{{ product.common_info[0].memo ? `，${product.common_info[0].memo}` : '' }}</span>
          </div>
        </div>
        <div class="base-info-item">
          <div class="item-label">入境次数</div>
          <div class="item-content">
            <span v-if="product.common_info[2].type === 0">{{ product.common_info[2].num }}{{ product.common_info[2].unit }}</span>
            <span v-else>{{ product.common_info[2].unit }}{{ product.common_info[2].memo ? `，${product.common_info[2].memo}` : '' }}</span>
          </div>
        </div>
        <div class="base-info-item">
          <div class="item-label">停留时长</div>
          <div class="item-content">
            <span v-if="product.common_info[1].type === 0">{{ product.common_info[1].num }}{{ product.common_info[1].unit }}</span>
            <span v-else>{{ product.common_info[1].unit }}{{ product.common_info[1].memo ? `，${product.common_info[1].memo}` : '' }}</span>
          </div>
        </div>
        <div class="base-info-item" v-if="product.need_interview || product.need_delivery">
          <div class="item-label">是否需要预约</div>
          <div class="item-content">
            <span >{{ product.need_interview || product.need_delivery ? "是" : "否" }}</span>
            <country-appointment-earliest-date
              :product="product"
              :country-id="product.visa_country_id"
            ></country-appointment-earliest-date>
            
          </div>
        </div>
      </div>
      <div class="right-box" v-if="User.isLogin()">
        <service-assurance></service-assurance>
      </div>
      
    </div>

    <!-- 分享给顾客 -->
    <common-share-wxa-dialog
      :visible.sync="shareModalShow"
      title="分享给顾客"
      page="pages/visa/visa-detail/visa-detail"
      :scene="`v=${product.visa_product_id}&a=${User.peer_account_id}&p=${province_code}`"
      methods-one-title="扫描二维码后分享给顾客"
      :step-one-desc="product.product_name"
      step-two-title="点击分享给好友"
      :step-two-img="share2Url"
      methods-two-tips="复制链接并发送给客户，客户可在微信上直接打开上传资料"
      page-from="商品详情页"
    ></common-share-wxa-dialog>

    <!-- 商品已经无法办理 -->
    <cant-book-modal
      v-model="cantBookShow"
      :product="product"
      :codeImg="codeUrl"
    ></cant-book-modal>

    <created-order-dialog
      :visible.sync="addOrderModalShow"
      :product="product"
      :from="from"
      @share-product="shareToCustomer"
    ></created-order-dialog>
    

    <!-- 添加订单 -->
    <!-- <add-order
      :open="addOrderModalShow"
      :product="product"
      :peer="peer"
      :country-id="product.visa_country_id"
      :country-url="product.website_bkg_img || product.national_flag_img"
      :from="from"
      :selected-reject-product-id="selectedRejectProductId"
      @modalClose="addOrderModalShow = false"
    ></add-order> -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import sensorsdata from 'sa-sdk-javascript';
import dayjs from 'dayjs';
import addOrder from '@/components/add-order/add-order';
import cantBookModal from '@/components/product/cant-book-modal';
import User from '../../../../libs/user';
import share2Url from '../../../../assets/imgs/share2.gif';
import Http from '../../../../libs/http';
import CollapseBox from '../../../../components/common/collapse/collapse-box';
import CollapseBtn from '../../../../components/common/collapse/collapse-btn';
import CollapseContent from '../../../../components/common/collapse/collapse-content';
import CountDown from './count-down.vue';
import utils from '../../../../libs/utils';
import productService from '../../../../services/product-service';
import CreatedOrderDialog from '@/components/add-order/created-order/created-order-dialog.vue';
import CommonShareWxaDialog from '../../../../components/common/share/common-share-wxa-dialog.vue';
import BaseTextCopy from '../../../../components/common/base-text-copy.vue';
import CountryAppointmentEarliestDate from './visa-top-infos-components/country-appointment-earliest-date.vue';
import ServiceAssurance from './visa-top-infos-components/service-assurance.vue';

export default {
  name: 'visa-top-infos',
  components: {
    addOrder,
    cantBookModal,
    CollapseBox,
    CollapseBtn,
    CollapseContent,
    CountDown,
    CreatedOrderDialog,
    CommonShareWxaDialog,
    BaseTextCopy,
    CountryAppointmentEarliestDate,
    ServiceAssurance,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    peer: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    from: String,
    commentTotal: {
      type: Number,
      default: 0,
    },
    province_code: Number,
  },
  data() {
    return {
      dayjs,
      share2Url,
      shareModalShow: false,
      cantBookShow: false,
      addOrderModalShow: false,
      codeUrl: '',
      User,
      earliestDepartDate: '',
      productCoupons: [],
      visaTypeMap: {
        旅游签: {
          bgColor:
            'linear-gradient(135deg,rgba(123,179,242,1) 0%,rgba(84,148,221,1) 100%)',
        },
        商务签: {
          bgColor:
            'linear-gradient(135deg,rgba(94,211,187,1) 0%,rgba(61,187,162,1) 100%)',
        },
        探亲访友签: {
          bgColor:
            'linear-gradient(135deg,rgba(161,154,223,1) 0%,rgba(130,122,202,1) 100%)',
        },
        短期学习签: {
          bgColor:
            'linear-gradient(135deg,rgba(251,143,143,1) 0%,rgba(240,99,99,1) 100%)',
        },
        医疗签: {
          bgColor:
            'linear-gradient(135deg,rgba(238,214,104,1) 0%,rgba(237,184,80,1) 100%)',
        },
        访问签: {
          bgColor:
            'linear-gradient(135deg,rgba(116,208,247,1) 0%,rgba(72,185,233,1) 99%)',
        },
        免签: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        落地签: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        过境签: {
          bgColor:
            'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)',
        },
        香港L签过关服务: {
          bgColor:
            'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)',
        },
        入台证: {
          bgColor:
            'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)',
        },
        展会签: {
          bgColor:
            'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)',
        },
        EVUS登记: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        公证认证: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        公证: {
          bgColor:
            'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)',
        },
        签注续签: {
          bgColor:
            'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)',
        },
        '国际驾照（KIDA）': {
          bgColor:
            'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)',
        },
        香港驾照: {
          bgColor:
            'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)',
        },
        入金证: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        香港签注续签: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        qita: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        }, // 此处故意用英文区分
      },
      specialProduct: [], // 特殊的商品，下架也要显示
      endTime: '2023-07-27 10:06:00',
      selectedRejectProductId: '', // 选中的拒签无忧商品id
    };
  },
  computed: {
    ...mapState('user', ['peerCSData']),
    visaTypeBg() {
      if (!this.product.visa_product_id) return '';
      if (this.visaTypeMap[this.product.visa_type]) {
        return this.visaTypeMap[this.product.visa_type].bgColor;
      }
      // 没有找到对应的颜色，则取默认值
      return this.visaTypeMap.qita.bgColor;
    },
    // 需要的时间
    needDaysComputed() {
      const { need_days, need_days_longest } = this.product;
      if (need_days >= need_days_longest) {
        return need_days;
      }
      return `${need_days}-${need_days_longest}`;
    },
    needDaysTooltipContent() {
      return `从资料收齐后开始计算：\n\n资料审核：预计${
        this.product.op_need_days
      }工作日；\n使馆审核：预计${
        this.needDaysComputed
      }工作日；\n\n${this.product.need_days_detail}\n\n出签后如需邮寄还需1-2日快递时间，因使馆系统原因，送签时效及出签时间不稳定，下单前请考虑时间因素，勿提前购买机票酒店！`;
    },

    
    firstThreeCoupons() {
      if (this.productCoupons.length <= 3) {
        return this.productCoupons;
      }
      return this.productCoupons.slice(0, 3);
    },
    // 服务包含
    serviceInclude() {
      return this.product.basic_info.find(item => item.title === '服务包含');
    },
    productShowPrice() {
      return productService.getSalesPrice(this.product);
    },
    formatDiscount() {
      return utils.formatNumberWithDecimals(this.product.available_coupon_info.cash_reduce / 1000);
    },
    // 七天以上，才显示tag, 否则显示倒计时
    isShowSpecialPriceTag() {
      if (!this.product) return false;
      // 没有特价结束日期，那就直接显示tag
      if (!this.product.special_end_date) return true;
      // 七天以上，显示特价标签
      return dayjs(this.product.special_end_date).isAfter(dayjs().add(6, 'day'), 'days');
    },
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    ...mapActions('config/', ['getSysConfig']),
    // 跳转到登录
    goToLogin() {
      this.SHOW_LOGIN_BOX();
    },

    // 分享给顾客
    shareToCustomer() {
      // 未登录跳转到登录
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_share' });
        return;
      }

      // 未绑定跳转到绑定
      if ((!User.wxinfo || !User.wxinfo.openid) && !User.is_palmyou) {
        return this.$router.push({
          name: 'bind',
          query: { redirectUrl: encodeURIComponent(this.$route.fullPath) },
        });
      }
      this.shareModalShow = true;

      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/xbb_record_add', {
          visa_product_id: this.product.visa_product_id,
          record_type: 2,
        });
      }
      // 工单埋点
      this.workOrderRecord();
    },

    // 工单埋点
    workOrderRecord() {
      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/peer_behavior_record_add', {
          visa_product_id: this.product.visa_product_id, // 签证产品id,  behavior_type_id = 10002:浏览商详页/10007:分享商详页必填
          behavior_type_id: 10007, // 10001:浏览商品列表页, 10002:浏览商详页, 10003:添加申请人, 10007:分享商详页, 10008:分享店铺
        });
      }
    },

    // 获取最早可出行日期
    getEarliestDepartDate(offline) {
      Http.post('/sys/visa_product_earliest_depart_date_query', {
        visa_product_id: this.product.visa_product_id,
        offline,
      }).then((res) => {
        this.earliestDepartDate = moment(res.earliest_depart_date).format(
          'YYYY-MM-DD',
        );
      });
    },

    // 获取同业当前对这个商品可用的优惠券
    getPeerCouponForCurrentProduct() {
      if (User.isLogin()) {
        Http.post('/visa_product_coupon_query', {
          visa_product_id: this.product.visa_product_id,
        }).then((data) => {
          this.productCoupons = data.product_coupon;
        });
      }
    },

    // 立即下单
    addOrderNow() {
      // 未登录
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_apply_now' });
        return;
      }

      // 未绑定
      if ((!User.wxinfo || !User.wxinfo.openid) && !User.is_palmyou) {
        return this.$router.push({
          name: 'bind',
          query: { redirectUrl: encodeURIComponent(this.$route.fullPath) },
        });
      }

      // 神策埋点
      sensorsdata.track('ProductDetailStart', {
        country: this.product.visa_country_name,
        visa_product_id: this.product.visa_product_id,
        product_name: this.product.product_name,
        visa_type: this.product.visa_type,
        peer_name: this.peer.peer_name,
        user_type: '同业',
        need_online_application: Boolean(
          this.product.visa_application &&
            this.product.visa_application.visa_application_id,
        ),
        need_interview: Boolean(
          this.product.need_interview || this.product.need_delivery,
        ),
        customer_service: (this.peerCSData && this.peerCSData.cs_name) || '',
      });

      // 打开对话框
      this.addOrderModalShow = true;
    },
    showSpecialTips() {
      this.$message.info('该商品本月名额已满，可咨询商务经理进行预订');
    },
  },
  watch: {
    product(newVal) {
      if (newVal.visa_product_id) {
        this.getEarliestDepartDate(1);
        this.getPeerCouponForCurrentProduct();
      }
    },
  },
  created() {
    this.getEarliestDepartDate(1);
    this.getPeerCouponForCurrentProduct();
    this.getSysConfig().then((data) => {
      this.specialProduct = data.visa_product_list;
    });
  },
};
</script>

<style lang="less" scoped>
#visa-top-infos {
  background-color: white;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  width: 100%;
  padding: 12px 0 16px 0;
  position: relative;

  .info-header {
    margin-bottom: 16px;
    padding: 0 16px;
    .row-one {
      display: flex;
      align-items: flex-start;
      .visa-product-name {
        flex-grow: 1;
        display: inline-flex;
        font-size: 30px;
        line-height: 42px;
        color: #2F333D;
        font-weight: 600;
        margin-bottom: 16px;
        position: relative;
        .product-out-icon {
          width: 64px;
          height: 64px;
          background: url(../../../../assets/imgs/product-detail/product-out.png)
            no-repeat center / 100% 100%;
          position: absolute;
          right: -50px;
          top: -2px;
          transform: rotate(15deg);
        }
      }
      .close-box {
        margin-left: 70px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        padding: 4px;
        cursor: pointer;
        .icon-close {
          width: 24px;
          height: 24px;
          background: url(../../../../assets/imgs/product-detail/icon-close.png)
            no-repeat center / 100% 100%;
        }
      }
    }
    .row-two {
      display: flex;
      align-items: center;
      .left-box {
        flex-grow: 1;
        display: flex;
        align-items: center;
        .visa-tags {
          display: flex;
          align-items: center;
          .tag-item {
            height: 24px;
            margin-right: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            border-radius: 1px;
            padding: 0 12px;
            &:last-child {
              margin-right: 0;
            }
            &.primary {
              background: linear-gradient(
                135deg,
                rgba(123, 179, 242, 1) 0%,
                rgba(94, 155, 225, 1) 100%
              );
              color: #fff;
            }
            &.red-tag {
              background: fade(#ff5a60, 8);
              color: #ff5a60;
            }
            &.blue-tag {
              background: fade(#3fa2f5, 8);
              color: #5da6e5;
            }
            &.green-tag {
              background: fade(#3dcebf, 8);
              color: #3dcebf;
            }

          }
          .need-reject-label {
            width: 83px;
            height: 24px;
            margin-left: 4px;
            background: url(../../../../assets/imgs/product-detail/visa-reject-refund-product1.png) no-repeat center / 100% 100%;
          }
        }

        .product-num {
          margin-left: 10px;
          color: #c9cdd1;
          font-size: 14px;
          line-height: 20px;
        }
      }

      .right-box {
        flex-shrink: 0;
        margin-left: 24px;
        .update-time {
          color: #91999f;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .product-price-info-wrap{
    background: linear-gradient(
      90deg,
      rgba(255, 223, 204, 0.08) 0%,
      rgba(255, 128, 51, 0.08) 100%
    );
    padding: 0 16px;
  }

  .price-and-coupon {
    display: flex;
    align-items: center;
    padding: 12px 0;
    .product-price-box {
      flex-grow: 1;
      line-height: 1;
      .price-box {
        display: flex;
        align-items: flex-end;
        .special-price-tag {
          width: 60px;
          height: 17px;
          background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/special-tag.png)
            no-repeat center / 100% 100%;
          background-size: cover;
          margin-right: 8px;
        }
        .coupon-price-tag {
          color: #FF8033;
          font-size: 14px;
          line-height: 18px;
          font-weight: 600;
          margin-right: 8px;
        }
        .current-price {
          display: flex;
          align-items: flex-end;
          color: #ff8033;
          font-weight: 600;
          .price-sign {
            font-size: 20px;
          }
          .price-number {
            font-size: 32px;
            line-height: 26px;
          }
          .pre{
            font-size: 14px;
            margin-left: 4px;
            transform: translateY(-1px);
          }
        }
        .login-btn {
          margin-left: 12px;
          width: 72px;
          height: 24px;
          border-radius: 1px;
          border: 1px solid #599fff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #599fff;
          font-size: 12px;
          cursor: pointer;
        }

        .origin-price {
          margin-left: 7px;
          color: #91999f;
          font-size: 12px;
          .origin-price-number {
            text-decoration: line-through;
          }
        }

  
        .entri-special-price {
          margin-left: 12px;
          height: 24px;
          padding: 0 10px;
          background: #fff6dd;
          display: flex;
          align-items: center;
          justify-self: center;
          color: #6f6f6f;
          font-size: 12px;
          line-height: 12px;
          .special-price-text {
            color: #ff8033;
          }
        }

        .coupon-box{
          padding: 0 8px;
          height: 18px;
          border-radius: 10px;
          border: 1px solid #FF8033;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #FF8033;
          font-size: 12px;
          margin-left: 20px;
        }
      }
      .product-price-bottom {
        margin-top: 12px;
        color: #91999f;
        font-size: 12px;
        display: flex;
        
        .suggestion-price {
          color: #91999f;
          font-size: 12px;
        }
        span {
          margin-right: 2px;
        }
      }
    }
    .hanle-buttons {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      .visa-comment {
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        color: #2f333d;
        line-height: 16px;
        margin-right: 20px;
        > span {
          font-size: 14px;
          font-weight: 400;
          color: #6f6f6f;
          line-height: 14px;
        }
      }

      .create-order-btn-list {
        display: flex;
        align-items: center;
        .hover-handle-btn {
          margin-right: 12px;
        }
        .handle-btn {
          width: 112px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: transparent;
          border: 1px solid #ff8033;
          font-size: 16px;
          line-height: 1;
          border-radius: 2px;
          color: #ff8033;
          outline: none;
          cursor: pointer;
          &.primary {
            background: #ff8033;
            color: #fff;
          }
          &.disabled {
            background: #ffccad;
            border: none;
            color: #fff;
            cursor: not-allowed;
          }
          &.is-share{
            display: flex;
            flex-direction: column;
            align-items: center;
            .btn-subtitle{
              font-size: 10px;
              line-height: 14px;
              margin-top: 1px;
              letter-spacing: 1.6px;
            }
          }
        }
        .handle-btn + .handle-btn {
          margin-left: 12px;
        }
      }

    }
  }

  .price-desc-box{
    border-top: 1px solid #E9EEF2;
    padding: 12px 0;
    .desc-item{
      display: flex;
      align-items: flex-start;
      font-size: 12px;
      .item-label{
        flex-shrink: 0;
        line-height: 24px;
        color: #2F333D;
      }
      .item-content{
        white-space: pre-wrap;
        color: #5F666E;
        line-height: 16px;
        padding: 4px 0;
      }
    }
  }
  .product-base-info{
    padding: 20px 16px 0 16px;
    display: flex;
    align-items: flex-start;
    .left-box{
      flex-grow: 1;
      overflow: hidden;
      .base-info-item{
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 12px;
        &:last-child{
          margin-bottom: 0;
        }

        .item-label{
          color: #5F666E;
          flex-shrink: 0;
          width: 116px;
        }
        .item-content{
          color: #2F333D;
          display: flex;
          align-items: center;
          .tooltip-icon{
            background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/icon-query.png) no-repeat center / 100% 100%;
            width: 16px;
            height: 16px;
            margin-left: 4px;
            cursor: pointer;
          }
        }
      }
    }
    .right-box{
      flex-shrink: 0;
      position: relative;
      width: 250px;
    }
    
    
  }
}
</style>
<style lang="less">
.new-visa-top-infos-tooltip {
  max-width: 300px;
  line-height: 16px;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-top-infos.vue